import { Fade } from '@mui/material';
import React, { ChangeEvent, FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize, fontWeight, TypographyStyledGlobal } from '../../../theme';
import Title from '../../Title/title';
import SimpleActionButton from '../ActionButton/simpleActionButton';
import { InputStyled, StyledFormControl } from '../AddDashboardModal/styled';
import { CloseIconModalStyled, ModalStyled } from '../DashboardModal/styled';
import BoxModalStyled, { ErrorInputMessageStyled } from '../styled';

interface AddTenantModalInterface {
    handleClose: () => void
    openModal: boolean
    sendValue: (value: string) => void
    title: string
    labelInput: string
    placeholder: string
    labelButton: string
    value?:string
}

const AddTenantModal: FC<AddTenantModalInterface> = ({ handleClose, openModal, sendValue, title, labelInput, placeholder, labelButton, value }) => {
    const { t } = useTranslation('settings');
    const [tenantValue, setTenantValue] = useState<string>(value || '');
    const [errorMessage, setErrorMessage] = useState<string>('');

    const handleChangeTenant = (e: ChangeEvent<HTMLInputElement>) => {
        setTenantValue(e.target.value);
    };
    const handleAddTenant = () => {
        if (tenantValue) {
            setErrorMessage('');
            sendValue(tenantValue);
            handleClose();
        } else {
            setErrorMessage(t('tenants.modal.errorInputMessage'));
        }
    };

    return (
        <ModalStyled
            aria-describedby="modal-modal-description"
            aria-labelledby="modal-modal-title"
            onClose={handleClose}
            open={openModal}
        >
            <Fade in={openModal}>
                <BoxModalStyled>
                    <Title content={title} modalTitle />
                    <CloseIconModalStyled onClick={handleClose} />
                    <StyledFormControl>
                        <TypographyStyledGlobal
                            color={colors.grey200}
                            size={fontSize.m}
                            weight={fontWeight.regular}
                        >
                            {labelInput}
                        </TypographyStyledGlobal>
                        <InputStyled
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeTenant(e)}
                            placeholder={placeholder}
                            value={tenantValue}
                        />
                        {errorMessage && (
                            <ErrorInputMessageStyled>{errorMessage}</ErrorInputMessageStyled>
                        )}
                        <SimpleActionButton
                            handleClickConfirm={handleAddTenant}
                            labelConfirm={labelButton}
                        />
                    </StyledFormControl>
                </BoxModalStyled>
            </Fade>
        </ModalStyled>
    );
};

export default AddTenantModal;
